import { DynamicSchema } from '@soniq/schema'
import { definitions } from '../../.types/Invite.schema.json'
import { InviteSchema } from '../../.types/Invite.schema'
export type {
  InviteSchema,
  ConnectStudentInvite,
  GoldenTicketInvite,
} from '../../.types/Invite.schema'
export * from './guards'
export const inviteJsonSchema = {
  ...definitions.InviteSchema,
  definitions,
}
export const inviteSchema = DynamicSchema.new<InviteSchema>({
  id: 'InviteSchema',
  jsonSchema: inviteJsonSchema,
})
export * from './types'
